import { useState, useEffect } from 'react';
import { resolveCustomDomain } from '../services/api';

const PLATFORM_HOSTNAMES = (process.env.REACT_APP_PLATFORM_HOSTNAMES || 'localhost')
  .split(',')
  .map((h) => h.trim());

function isPlatformHostname(hostname) {
  return PLATFORM_HOSTNAMES.includes(hostname);
}

export function useCustomDomain() {
  const [state, setState] = useState({
    isCustomDomain: false,
    organizationId: null,
    restaurantId: null,
    type: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const hostname = window.location.hostname;

    if (isPlatformHostname(hostname)) {
      setState({
        isCustomDomain: false,
        organizationId: null,
        restaurantId: null,
        type: null,
        loading: false,
        error: null,
      });
      return;
    }

    // Check sessionStorage cache
    const cached = sessionStorage.getItem(`domain:${hostname}`);
    if (cached) {
      const data = JSON.parse(cached);
      setState({
        isCustomDomain: true,
        organizationId: data.organizationId || null,
        restaurantId: data.restaurantId || null,
        type: data.type || null,
        loading: false,
        error: null,
      });
      return;
    }

    resolveCustomDomain(hostname)
      .then((data) => {
        sessionStorage.setItem(`domain:${hostname}`, JSON.stringify(data));
        setState({
          isCustomDomain: true,
          organizationId: data.organizationId || null,
          restaurantId: data.restaurantId || null,
          type: data.type || null,
          loading: false,
          error: null,
        });
      })
      .catch((err) => {
        setState({
          isCustomDomain: true,
          organizationId: null,
          restaurantId: null,
          type: null,
          loading: false,
          error: err.message || 'Domain not found',
        });
      });
  }, []);

  return state;
}
